export const environment = {
  production: true,
  development: false,
  staging: false,
};
